import { render } from "./VideosEquipmentSlick.vue?vue&type=template&id=48bf3e09"
import script from "./VideosEquipmentSlick.vue?vue&type=script&lang=js"
export * from "./VideosEquipmentSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/VideosEquipmentSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48bf3e09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48bf3e09', __exports__)) {
    api.reload('48bf3e09', __exports__)
  }
  
  module.hot.accept("./VideosEquipmentSlick.vue?vue&type=template&id=48bf3e09", () => {
    api.rerender('48bf3e09', render)
  })

}


export default __exports__